import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState } from 'recompose';

import './style.scss';

const Filter = ({
  id,
  name,
  groupId,
  selectedFilters,
  setFilters,
  isChecked,
  setChecked,
  onSelectChange,
}) => (
  <div className="filter">
    <input
      id={`filter${groupId}${id}`}
      className="filter__checkbox"
      type="checkbox"
      checked={isChecked}
      onClick={() => {
        const filters = { ...selectedFilters };

        if (!isChecked) { // cause setChecked in the end
          if (filters[groupId]) {
            filters[groupId].push(id);
          } else {
            filters[groupId] = [id];
          }
        } else if (filters[groupId]) {
            filters[groupId].splice(filters[groupId].indexOf(id), 1);
          }

        setFilters(filters);
        setChecked(!isChecked);
        onSelectChange({ filters });
      }}
    />
    <label
      htmlFor={`filter${groupId}${id}`}
      className={`filter__label
      ${groupId === 5 ? 'filter__label__upper' :
        groupId === 4 ? 'filter__label__capitalize' : ''}
        ${name === 'Акция' ? ' filter__label__red' : ''}`}
    >
      {name}
    </label>
  </div>
);

Filter.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  isChecked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
};

export default compose(
  withState('isChecked', 'setChecked', false),
)(Filter);



// WEBPACK FOOTER //
// ./src/components/ui/FiltersContainer/FiltersGroup/Filter/index.js